export const GOOGLE_MARKER_SIGNATURE = 'Google marker';

export const MAP_IDS = {
  google: 1,
  yandex: 2,
};

export const MAP_NAMES = {
  google: 'Google Map',
  yandex: 'Yandex Map',
} as const;

export type MapName = (typeof MAP_NAMES)[keyof typeof MAP_NAMES];

export const MAP_TYPES = {
  HYBRID: 'hybrid',
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  TERRAIN: 'terrain',
} as const;

export type MapTypeKeys = keyof typeof MAP_TYPES;
export type MapType = (typeof MAP_TYPES)[MapTypeKeys];

export const DEFAULT_CENTER = {
  lat: 37.444585,
  lng: 65.607399,
};
